import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Base from './base';
/**
 * `Service` The markup service, is used to fetch markup related data.
 */
var MarkupService = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function MarkupService(sdk) {
    _classCallCheck(this, MarkupService);
    return _callSuper(this, MarkupService, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(MarkupService, _Base);
  return _createClass(MarkupService, [{
    key: "getMarkupStats",
    value: (
    /**
     * Get the markup stats of sheets or documents, count of private and public markup.
     * The response is in Camel Case format.
     *
     * @param projectId -  the project uuid
     * @param payload -
     * \{
     *   type: 'acc_sheet' or 'acc_document',
     *   entities: entityIds(sheet id or document version id)
     * \};
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{"results":[\{"personal": 3, "published": 2, "uid":surfaceId\}]\}
     */
    function () {
      var _getMarkupStats = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/base_entity_/stats");
              _context.next = 3;
              return this.HttpService.markup.post(url, payload, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getMarkupStats(_x, _x2, _x3) {
        return _getMarkupStats.apply(this, arguments);
      }
      return getMarkupStats;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Markup';
    }
  }]);
}(Base);
export default MarkupService;